<app-dialog class="confirm-dialog">
  <app-dialog-header>
    {{ data.title }}
  </app-dialog-header>

  <app-dialog-content
    class="confirm-modal__text"
    [innerHTML]="(data && data.text) ?? ''"
  />

  <app-dialog-footer justifyContent="space-between">
    <button
      appButton
      variant="outlined"
      size="medium"
      (click)="closeDialog()"
    >
      @if (data && data.cancelLabel) {
        {{ data.cancelLabel }}
      } @else {
        {{ 'shared.components.ui.confirm-dialog.cancel.label' | translate }}
      }
    </button>

    <button
      appButton
      size="medium"
      [color]="data.variant === 'danger' ? 'danger' : 'primary'"
      (click)="apply()"
    >
      @if (data && data.applyLabel) {
        {{ data.applyLabel }}
      } @else {
        {{ 'shared.components.ui.confirm-dialog.confirm.label' | translate }}
      }
    </button>
  </app-dialog-footer>
</app-dialog>
